import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stktm { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '單號 (TM001) 不可空白'}) 
    @MaxLength(13,{message: '單號 (TM001) 資料太長'})
    TM001: string = '';            // 單號 13 

    @IsNotEmpty({message: '商品代號 (TM002) 不可空白'}) 
    @MaxLength(10,{message: '商品代號 (TM002) 資料太長'})
    TM002: string = '';            // 商品代號 10 

    @IsNotEmpty({message: '商品名稱 (TM003) 不可空白'}) 
    @MaxLength(16,{message: '商品名稱 (TM003) 資料太長'})
    TM003: string = '';            // 商品名稱 16 

    @IsNotEmpty({message: '結案碼 (TM004) 不可空白'}) 
    @MaxLength(1,{message: '結案碼 (TM004) 資料太長'})
    TM004: string = 'N';            // 結案碼 1 [DEF:"N"] {{N:未結案 Y:結案}}


    TM005: Date | undefined;            // 更新日期時間 0 

    @MaxLength(10,{message: '狀態 (TM006) 資料太長'})
    TM006: string = '';            // 狀態 10 

    @MaxLength(8,{message: '設定日期 (TM007) 資料太長'})
    TM007: string = '';            // 設定日期 8 

    @IsNumber() 
    TM008: number = 0;            // 庫存數量 8.3 

    @IsNumber() 
    TM009: number = 0;            // 最大數量 8.3 

    @IsNumber() 
    TM010: number = 0;            // 平均成本 8.3 

    @MaxLength(10,{message: '使用者代號 (TM011) 資料太長'})
    TM011: string = '';            // 使用者代號 10 

    @MaxLength(200,{message: '觀盤重點 (TM012) 資料太長'})
    TM012: string = '';            // 觀盤重點 200 

    @MaxLength(6,{message: '帳號代號 (TM013) 資料太長'})
    TM013: string = '*';            // 帳號代號 6 [DEF:"*"] STKLE STK.MJ001

    @MaxLength(10,{message: '群組代號 (TM014) 資料太長'})
    TM014: string = '000';            // 群組代號 10 [DEF:"000"] STKME

    @IsNumber() 
    TM015: number = 0.05;            // 保留 8.3 [DEF:0.05] 大紅K棒實體N%以上  MJ011

    @IsNumber() 
    TM016: number = 0.02;            // 保留 8.3 [DEF:0.02] 小紅K棒實體N%以上                                MJ012

    @IsNumber() 
    TM017: number = 2;            // 保留 8.2 [DEF:2]        超過五日均量N倍                                              MJ013

    @IsNumber() 
    TM018: number = 0;            // 保留 8.4 漲幅 3%  到價上限幅度警示%                                             MJ014

    @IsNumber() 
    TM019: number = 0;            // 保留 8.4 到價下限幅度警示%                                                         MJ015

    @IsNumber() 
    TM020: number = 0;            // 保留 8.4 3%  跌幅%                                                          MJ016

    @IsNumber() 
    TM021: number = -0.05;            // 保留 8.3 [DEF:-0.05]  大黑K棒實體N%以上                                                MJ017

    @IsNumber() 
    TM022: number = -0.02;            // 保留 8.3 [DEF:-0.02]  小黑K棒實體N%以上                                               MJ018

    @MaxLength(1,{message: '啟用 (TM023) 資料太長'})
    TM023: string = 'Y';            // 啟用 1 [DEF:"Y"]                                                    MJ019

    @MaxLength(8,{message: '保留 (TM024) 資料太長'})
    TM024: string = '09:00:00';            // 保留 8 [DEF:"09:00:00"]   改到STKMA 開始時間?                                          MJ020

    @MaxLength(8,{message: '設定時間 (TM025) 資料太長'})
    TM025: string = '13:30:00';            // 設定時間 8 [DEF:"13:30:00"]   結束時間?                                          MJ021

    @IsNumber() 
    TM026: number = 5;            // 排序 6 [DEF:5]      格時間(分)                                      MJ022  20230323 MODI

    @MaxLength(1,{message: '通知方法 (TM027) 資料太長'})
    TM027: string = 'T';            // 通知方法 1 [DEF:"T"] {{L:Line T:TELEGRAM  M:MAIL P:推播}}                   MJ023

    @MaxLength(1,{message: '通知頻率 (TM028) 資料太長'})
    TM028: string = '1';            // 通知頻率 1 [DEF:"1"] {{1:只一次  2:通知到已讀  3:不斷通知}}  STK.LE008='Y'  MJ024

    @MaxLength(8,{message: '上次通知日期 (TM029) 資料太長'})
    TM029: string = '';            // 上次通知日期 8 MJ025

    @MaxLength(8,{message: '上次通知時間 (TM030) 資料太長'})
    TM030: string = '';            // 上次通知時間 8 01:23:45                                                     MJ026

    @MaxLength(1,{message: '保留 (TM031) 資料太長'})
    TM031: string = 'N';            // 保留 1 [DEF:"N"]  大紅K棒實體N%以上                                                  MJ111

    @MaxLength(1,{message: '保留 (TM032) 資料太長'})
    TM032: string = 'N';            // 保留 1 [DEF:"N"]  小紅K棒實體N%以上                                                  MJ112

    @MaxLength(1,{message: '保留 (TM033) 資料太長'})
    TM033: string = 'N';            // 保留 1 [DEF:"N"] 超過五日均量N倍                                                   MJ113

    @MaxLength(1,{message: '保留 (TM034) 資料太長'})
    TM034: string = 'N';            // 保留 1 [DEF:"N"] 到價上限幅度警示                                                   MJ114

    @MaxLength(1,{message: '保留 (TM035) 資料太長'})
    TM035: string = 'N';            // 保留 1 [DEF:"N"] 到價下限幅度警示                                                   MJ115

    @MaxLength(1,{message: '保留 (TM036) 資料太長'})
    TM036: string = 'N';            // 保留 1 [DEF:"N"] 跌幅 同MJ115?                                           MJ116

    @MaxLength(1,{message: '保留 (TM037) 資料太長'})
    TM037: string = 'N';            // 保留 1 [DEF:"N"] 大黑K棒實體N%以上                                     MJ117

    @MaxLength(1,{message: '保留 (TM038) 資料太長'})
    TM038: string = 'N';            // 保留 1 [DEF:"N"]  小黑K棒實體N%以上                                                  MJ118

    @MaxLength(1,{message: '保留 (TM039) 資料太長'})
    TM039: string = 'N';            // 保留 1 [DEF:"N"]  (保留)三陽開泰且爆量小紅                                                   MJ119

    @MaxLength(1,{message: '保留 (TM040) 資料太長'})
    TM040: string = 'N';            // 保留 1 [DEF:"N"]       (保留)四海遊龍且爆量小紅                                              MJ120

    @IsNumber() 
    TM041: number = 0;            // 買進張數 8.3 MA051

    @IsNumber() 
    TM042: number = 0;            // 最大張數 8.3 MA052

    @IsNumber() 
    TM043: number = 0;            // 昨收 8.3 MA053

    @IsNumber() 
    TM044: number = 0;            // 預估損益 8 

    @IsNumber() 
    TM045: number = 5;            // 保留 6 [DEF:5]     排序

    @MaxLength(1,{message: '市場代號 (TM046) 資料太長'})
    TM046: string = '';            // 市場代號 1 MA019 capital:bstrMarketNo

    @IsNumber() 
    TM100: number = 0;            // 開盤價 11.2 LG007


    TM101: Date | undefined;            // 開盤時間 0 

    @IsNumber() 
    TM102: number = 0;            // 最高價 11.2 LG008


    TM103: Date | undefined;            // 最高價時間 0 

    @IsNumber() 
    TM104: number = 0;            // 最低價 11.2 LG009


    TM105: Date | undefined;            // 最低價時間 0 

    @IsNumber() 
    TM106: number = 0;            // 總成交量 8 LG005


    TM107: Date | undefined;            // 收盤價時間 0 LG012

    @IsNumber() 
    TM108: number = 0;            // 收盤價 11.2 LG010 最新一筆成交價格

    @IsNumber() 
    TM109: number = 0;            // 上次收盤價 11.2 LG011   用來檢查突破或跌破  最新一筆成交張數

    @IsNumber() 
    TM110: number = 0;            // 突破通知價 8.3 MA041 breakthrough

    @IsNumber() 
    TM111: number = 0;            // 跌破通知價 8.3 MA042 fellBelow

    @IsNumber() 
    TM112: number = 0;            // 停損價 8.3 MA043

    @IsNumber() 
    TM113: number = 0;            // 第一停利價 8.3 MA044 stopProfit1

    @IsNumber() 
    TM114: number = 0;            // 第二停利價 8.3 MA045 stopProfit2

    @IsNumber() 
    TM115: number = 0;            // 支撐1 8.3 MA048 sustain1

    @IsNumber() 
    TM116: number = 0;            // 支撐2 8.3 MA049 sustain2

    @IsNumber() 
    TM117: number = 0;            // 壓力 8.3 MA050 突破壓力買進

    @IsNumber() 
    TM118: number = 0;            // 智慧單買價 11.2 

    @IsNumber() 
    TM119: number = 0;            // 智慧單賣價 11.2 

    @IsNumber() 
    TM120: number = 0;            // 庫存量 11.3 

    @IsNumber() 
    TM121: number = 0;            // 保留 11.3 

    @IsNumber() 
    TM122: number = 0;            // 保留 11.3 

    @IsNumber() 
    TM200: number = 0;            // 保留 11 總量 nTQty

    @IsNumber() 
    TM201: number = 0;            // 保留 11 昨量  nYQty


}
